import { clsx } from 'clsx';
import { useLocation, useNavigate } from 'react-router';

import { appRoutes } from '@/routes/app-routes.ts';
import { useAuthStore, useModalStore } from '@/store';

import {
    BookedIcon,
    DrugomaniyaIcon,
    HomeIcon,
    MyNumbersIcon,
    ProfileIcon,
} from '../icons/header/menu';
import cn from './styles.module.scss';

const menuList = [
    {
        icon: HomeIcon,
        name: 'Главная',
        path: '/',
    },
    {
        icon: MyNumbersIcon,
        name: 'Мои номера',
        path: appRoutes.myNumbers,
    },
    {
        icon: DrugomaniyaIcon,
        name: 'Другомания',
        path: appRoutes.drugomaniya,
    },
    {
        icon: BookedIcon,
        name: 'Брони',
        path: appRoutes.myReservations,
    },
    {
        icon: ProfileIcon,
        name: 'Профиль',
        path: appRoutes.profile,
    },
];

export const MobileMenu = () => {
    const navigate = useNavigate();
    const { pathname } = useLocation();

    const { setIsOpen, setShowSignUp } = useModalStore();
    const { isAuth } = useAuthStore();

    const handleNavigate = (path: string) => {
        if (!isAuth) {
            if (path === '/' || path === appRoutes.profile || path === appRoutes.drugomaniya) {
                navigate(path);
            } else {
                setShowSignUp(true);
                setIsOpen(true);
            }
        } else {
            navigate(path);
        }
    };

    const isMainPage =
        pathname === '/' ||
        pathname.includes(appRoutes.prettyNums) ||
        pathname.includes(appRoutes.goodTariffs);

    return (
        <nav className={cn.mobileMenu}>
            {menuList.map(item => (
                <div
                    key={item.name}
                    onClick={handleNavigate.bind(null, item.path)}
                    className={clsx(
                        cn.mobileMenuItem,
                        (item.path === '/' ||
                        item.path.includes(appRoutes.prettyNums) ||
                        item.path.includes(appRoutes.goodTariffs)
                            ? isMainPage
                            : pathname.includes(item.path)) && cn.active
                    )}
                >
                    <div className={cn.mobileMenuItemIcon}>{item.icon}</div>
                    <div className={cn.mobileMenuItemName}>{item.name}</div>
                </div>
            ))}
        </nav>
    );
};
